import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
export const ChevronDoubleRight = props => {
    return (React.createElement(SvgIcon, Object.assign({}, props),
        React.createElement("path", { d: "M6.51351351,6 L13,12 L6.51351351,18 L5,16.6 L9.97297297,12 L5,7.4 L6.51351351,6 Z M13.5135135,6 L20,12 L13.5135135,18 L12,16.6 L16.972973,12 L12,7.4 L13.5135135,6 Z" })));
};
export default ChevronDoubleRight;
